'use strict';

/**Minimessages can override older minimessages. For important messages, use dialogmessage instead.
 */

angular
  .module('v6CoreModule')
  .directive('miniMessage', ($rootScope, $timeout, translate) => ({
    template:
      '<span class="miniMessage {{ministyle}}" show-class="miniBoolean,lineRollIn, lineRollOut">{{minimsg}} <span ng-repeat="link in links"><a ng-click="callback(link)">{{link.message}}</a> </span></span>',

    link: function (scope, element, attrs) {
      const $translate = translate;

      scope.ministyle = '';
      scope.links = [];
      scope.minimsg = '';
      scope.miniBoolean = false;
      let timer;
      scope.callback = (link) => {
        //condition to prevent double calling before mini dissappears from view
        if (scope.miniBoolean) {
          scope.miniBoolean = false;
          link.callback();
        }
      };
      $rootScope.$on('displayMiniMessage', (event, _options) => {
        scope.ministyle = String(_options.type);
        scope.minimsg = _options.message;
        scope.miniBoolean = true;
        let time = 3000;
        if (_options.time) {
          time = _options.time;
        }
        if (timer) {
          clearTimeout(timer);
        }
        if (_options.type == 'prompt' || _options.type == 'errorprompt') {
          scope.links = [
            {
              message: $translate.instant('yes'),
              callback: function () {
                _options.callback('yes');
              },
            },
            {
              message: $translate.instant('no'),
              callback: function () {
                _options.callback('no');
              },
            },
          ];
        } else {
          scope.links = [];
          timer = $timeout(() => {
            scope.miniBoolean = false;
          }, time);
        }
        if (_options.links) {
          scope.links = _options.links;
        }

        //giving a push to the show-class directive
        if (!scope.$$phase) {
          scope.$digest();
        }
      });
    },
  }));
